
export default class PollListItem {
    constructor(
        public readonly id: number,
        public readonly name: string,
        public readonly endOfVoteDate: moment.Moment| null,
        public readonly startedAt: moment.Moment | null
    ) { }
}